module.exports = __webpack_public_path__ + "img/logo.ccafc6e0.png";